import Lookup from 'src/componentes/select2';

const FusoHorarioLookup = ({ ...rest }) => <Lookup labelKey="nome" valueKey="id" url="/FusosHorariosLookup" {...rest} />;

export default FusoHorarioLookup;